import { render, staticRenderFns } from "./MailDetails.vue?vue&type=template&id=5a75cde5&scoped=true&"
import script from "./MailDetails.vue?vue&type=script&lang=js&"
export * from "./MailDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a75cde5",
  null
  
)

export default component.exports